import { bottomSidebarItems, sidebarItems } from '../configs/sidebar-items/sidebar-items.config';
import { footerLinks } from '../configs/footer-items/footer-items.config';
import { TranslateService } from '@ngx-translate/core';
import { FooterLink, SidebarItem } from '@siemens/component-lib';
import { TranslatedApplicationFrameItem } from './shared/interfaces/miscellaneous/TranslatedApplicationFrameItem';

export class AppComponentOperations {
    public static getInitializedApplicationFrameTranslations(
        translateService: TranslateService
    ): TranslatedApplicationFrameItem {
        const translatedSidebarItems: SidebarItem[] = sidebarItems.map(sidebarItem => ({
            ...sidebarItem,
            name: translateService.instant(sidebarItem.name),
            tooltip: translateService.instant(sidebarItem.tooltip)
        }));

        const translatedFooterItems: FooterLink[] = footerLinks.map(footerLink => ({
            ...footerLink,
            text: translateService.instant(footerLink.text)
        }));

        const translatedBottomSidebarItems: SidebarItem[] = bottomSidebarItems.map(bottomSidebarItem => ({
            ...bottomSidebarItem,
            name: translateService.instant(bottomSidebarItem.name),
            tooltip: translateService.instant(bottomSidebarItem.tooltip)
        }));
        return {
            sidebarItems: translatedSidebarItems,
            footerLinks: translatedFooterItems,
            bottomSidebarItems: translatedBottomSidebarItems
        };
    }
}
